import APP_DEFAULTS from '../constants/app-defaults';
import SpreeAPIProductAdapter from './ams-adapters/spree-api-product-adapter';

const request = require('superagent');

const ProductsAPI = {
    getList: (params = {}) => {
        const apiBase = process.env.REACT_APP_MAIN_STORE_API_HOST;
        const sanitizedQueryParams = {};

        sanitizedQueryParams.page = params.page_no || 1;
        sanitizedQueryParams.per_page = APP_DEFAULTS.perPage;

        if (params.taxonId) {
            sanitizedQueryParams['filter[taxons]'] = params.taxonId;
        }

        if (params.searchTerm) {
            sanitizedQueryParams['filter[name]'] = params.searchTerm;
        }

        if (params.price) {
            sanitizedQueryParams['filter[price]'] = params.price;
        }

        if (params.locale) {
            sanitizedQueryParams.locale = params.locale;
        }

        if (params.municipality) {
            sanitizedQueryParams.municipality = params.municipality;
        }

        return request
            // eslint-disable-next-line max-len
            .get(`${apiBase}/api/v2/storefront/products?zone_id=${params.zone || 6}&store_id=${params.storeId}&include=default_variant,variants,images,variants.images,variants.option_values,data_extra_types&sort=-updated_at`)
            .query(sanitizedQueryParams)
            .set('Accept', 'application/json')
            .then(
                (response) => {
                    response.body = SpreeAPIProductAdapter.processList(response.body);

                    return response;
                },
            );
    },

    getAllStoreList: (params = {}) => {
        const apiBase = process.env.REACT_APP_MAIN_STORE_API_HOST;
        const sanitizedQueryParams = {};

        sanitizedQueryParams.page = params.page_no || 1;
        sanitizedQueryParams.per_page = APP_DEFAULTS.perPage;

        if (params.searchTerm) {
            sanitizedQueryParams['filter[name]'] = params.searchTerm;
        }

        if (params.locale) {
            sanitizedQueryParams.locale = params.locale;
        }

        if (params.municipality) {
            sanitizedQueryParams.municipality = params.municipality;
        }

        return request
            // eslint-disable-next-line max-len
            .get(`${apiBase}/api/v2/storefront/products?zone_id=${params.zone || 6}&include=default_variant,variants,images,variants.images,variants.option_values&sort=-updated_at`)
            .query(sanitizedQueryParams)
            .set('Accept', 'application/json')
            .then(
                (response) => {
                    response.body = SpreeAPIProductAdapter.processList(response.body);

                    return response;
                },
            );
    },

    getItem: (productId, locale, zoneId) => {
        const sanitizedQueryParams = {};
        sanitizedQueryParams.locale = locale;

        return request
            // eslint-disable-next-line max-len
            .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/products/${productId}?include=default_variant,variants,images,variants.images,variants.option_values,data_extra_types&zone_id=${zoneId}`)
            .set('Accept', 'application/json')
            .query(sanitizedQueryParams)
            .then(
                (response) => {
                    response.body = SpreeAPIProductAdapter.processItem(response.body);

                    return response;
                },
            );
    },
};

export default ProductsAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/products.js
 **/